import { Card, CardContent, Grid, Stack, Typography } from "@mui/material";
import styled, { useTheme } from "styled-components";
import { Lightbulb } from "lucide-react";
import { useReport } from "../../contexts/ReportContext";

const StyledInfoStack = styled(Stack)(() => ({
  backgroundColor: "rgba(189, 147, 249, 0.1)",
  borderRadius: "50%",
  width: "40px",
  height: "40px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const InfoCard: React.FC<{ content: string }> = ({ content }) => {
  const { colorStyle } = useReport();
  const theme: any = useTheme();

  return (
    <Card>
      <CardContent>
        <Grid container spacing={2} alignItems="start">
          <Grid item>
            <StyledInfoStack>
              <Lightbulb
                color={theme.palette.reportColorStyles[colorStyle].main}
              />
            </StyledInfoStack>
          </Grid>
          <Grid item xs>
            <Typography variant="report.info.label" color="text.secondary">
              {content}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default InfoCard;
